import { useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App";
import { authStore } from "entities/Auth";
import {
  createRailSearchQueryParams,
  RailQueryParams,
  railSearchCardStore,
  RailSearchRequestFunc,
} from "entities/RailSearchCard";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { RequiredBy } from "shared/lib/typeCheck.lib";

import { getInitialSearchQPM } from "../ParamsManager";

type UseUrlQueryBasedInitialSearchProps = {
  searchController: {
    searchRequest: RailSearchRequestFunc;
    // getCards: GetRailCardsFunc;
    isSearchLoading: boolean;
  };
  openedCardAction: (card: ShipmentModel | null) => { type: string; payload: ShipmentModel | null };
};

type UseRailUrlQueryBasedInitialSearchReturnType = {
  railInitialSearch: ({ requestedFromUrl }: { requestedFromUrl: boolean }) => void;
};

export const useRailUrlQueryBasedInitialSearch = ({
  searchController,
  openedCardAction,
}: UseUrlQueryBasedInitialSearchProps): UseRailUrlQueryBasedInitialSearchReturnType => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const { showOpenedCardView } = usePanelViews();
  const { searchRequest, isSearchLoading } = searchController;
  const initialSearchQPM = useRef(getInitialSearchQPM()).current;
  const createRequestFuncByStrategy = (
    strategy: "authenticated" | "not-authenticated",
    requestParams: RequiredBy<RailQueryParams, "number">
  ): (() => void) | null => {
    const reqParams = createRailSearchQueryParams({
      requestType: "search",
      override: requestParams,
    });
    if (!reqParams) return null;

    switch (strategy) {
      case "authenticated":
        return () => {
          // getCards(
          //   { where: { reference: requestParams.number } },
          //   {
          //     onSettled: (userTrackingResponse) => {
          //       searchRequest(reqParams, {
          //         onSuccess: (trackingResponse) => {
          //           if (trackingResponse.rawDataParser.requestLimitReached) return;
          //           dispatch(setOpenedCardAction(trackingResponse));
          //         },
          //         onSettled: (trackingResponse) => {
          //           if (userTrackingResponse?.length) {
          //             dispatch(prependSavedCardAction({ data: userTrackingResponse[0] }));
          //             return;
          //           }
          //           if (trackingResponse && !trackingResponse?.rawDataParser.requestLimitReached) {
          //             dispatch(prependTrackingCardAction({ data: trackingResponse }));
          //           }
          //         },
          //       });
          //     },
          //   }
          // );
          searchRequest(reqParams, {
            onSuccess: (trackingResponse) => {
              if (trackingResponse.requestLimitReached) return;
              dispatch(openedCardAction(trackingResponse));
            },
            onSettled: (trackingResponse) => {
              //   if (userTrackingResponse?.length) {
              //     dispatch(prependSavedCardAction({ data: userTrackingResponse[0] }));
              //     return;
              //   }
              if (trackingResponse && !trackingResponse?.requestLimitReached) {
                dispatch(railSearchCardStore.actions.prependSearchCardAction({ data: trackingResponse }));
              }
            },
          });
        };
      case "not-authenticated":
      default:
        return () => {
          searchRequest(reqParams, {
            onSuccess: (trackingResponse) => {
              dispatch(railSearchCardStore.actions.prependSearchCardAction({ data: trackingResponse }));
              dispatch(openedCardAction(trackingResponse));
            },
          });
        };
    }
  };

  const railInitialSearch = ({ requestedFromUrl }: { requestedFromUrl: boolean }) => {
    if (!requestedFromUrl || isSearchLoading) return;

    const railReferenceQueryValue = initialSearchQPM.get("number") ?? initialSearchQPM.get("container");

    if (!railReferenceQueryValue) return;

    dispatch(appStore.actions.setRequestedFromUrl(true));

    showOpenedCardView();

    const requestFunc = createRequestFuncByStrategy(isAuthenticated ? "authenticated" : "not-authenticated", {
      number: railReferenceQueryValue,
    });

    requestFunc?.();
  };

  return { railInitialSearch };
};
